import { HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { TagSize } from "../Tag";

import styles from "./styles.module.scss";

export type TagCountProps = HTMLAttributes<HTMLSpanElement> & {
  tagSize?: TagSize,
}

export const TagCount = memo<TagCountProps>(({ tagSize = "md", className, children, ...props }) => {
  return (
    <span
      className={classNames(className, styles.countBlock, styles[tagSize as keyof typeof styles])}
      {...props}
    >
      {children}
    </span>
  );
});